import React, { FC } from 'react';
import { Badge, Stock } from 'modules/core/components';
import { useVehicleStatusBadgeProps } from 'modules/core/hooks';
import { IStock } from 'modules/core/components/Stock/Stock';
import { useDealSourceData } from 'hooks/useDealSourceData';
import { TableName } from 'modules/core/enums';

import { VEHICLE_STATUS_BADGE_PROPS } from '../../Badge/common.const';

interface IStockCell extends IStock {
  age: number | null;
  id: number;
  isNew?: boolean;
  isSold?: boolean;
  isLender?: boolean;
  isMakeItWork?: boolean;
}

export const StockCell: FC<IStockCell> = ({
  stock,
  id,
  isSold,
  age,
  isNew,
  isLender = false,
  isMakeItWork = false,
}) => {
  const badgeProps = useVehicleStatusBadgeProps(age, isNew, isSold);
  const { dealSourceData } = useDealSourceData(isLender ? TableName.LENDER : TableName.RAC);
  const isDealSourceVehicle = isMakeItWork && id === dealSourceData?.vehicle_id;

  return (
    <>
      <Stock stock={stock} />
      <br />
      {badgeProps && <Badge {...badgeProps} />}
      {isDealSourceVehicle && <Badge className="make-it-work-badge" {...VEHICLE_STATUS_BADGE_PROPS.MAKE_IT_WORK} />}
    </>
  );
};
